import { useShowMoreDescription } from './hooks/useShowMoreDescription'

type Props = {
  content: string
  className?: string
  rowLength?: number
}

export const ShowMoreDescription: React.FC<Props> = ({
  content,
  className = '',
  rowLength = 10,
}) => {
  const { textRef, cssProperties, hasMore, isOpen, open, close } =
    useShowMoreDescription(rowLength)

  return (
    <div className={className}>
      <p
        ref={textRef}
        className="overflow-y-hidden whitespace-pre-line text-[14px] leading-[1.8] xl:leading-[1.6]"
        style={cssProperties}
      >
        {content}
      </p>
      {hasMore &&
        (isOpen ? (
          <button
            className="hidden text-[13px] leading-[1.6] text-blue-500 xl:block"
            onClick={close}
            type="button"
          >
            閉じる
          </button>
        ) : (
          <button
            className="block text-[14px] leading-[1.8] text-blue-500 xl:pt-1 xl:leading-[1.6]"
            onClick={open}
            type="button"
          >
            ...もっと見る
          </button>
        ))}
    </div>
  )
}
